import { supabase } from "@/supabase";


export async function carregarNotacoes(ano, trimestres, disciplinas, estudantes) {
    const { data, error } = await supabase
        .from('notacoes')
        .select('*')
        .eq('ano_letivo', ano)
        .in('trimestre', trimestres)
        .in('disciplina', disciplinas)
        .in('estudante', estudantes)

    if (error) {
        console.log(error.message);
        return;
    }
    return data;

}

export async function carregarDesempenho(){

}